import { useEffect, useRef, useState } from 'react';
import type { SiteGateSession } from '../../hooks/useSiteGate.js';

/**
 * מסך "בקרוב" — עוטף את כל האפליקציה (מלבד /admin) כשהשער פעיל ועדיין נעול.
 * תמונת סוכן 013 מטושטשת ברקע; כפתור קטן ודיסקרטי בתחתית חושף טופס כניסה.
 */
export function ComingSoonGate({ session }: { session: SiteGateSession }) {
  const [showLogin, setShowLogin] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const usernameRef = useRef<HTMLInputElement | null>(null);

  // מיקוד בשדה הראשון אחרי שהטופס נחשף — preventScroll כדי שהדף לא "יקפוץ" (autoFocus רגיל גולל)
  useEffect(() => {
    if (showLogin) usernameRef.current?.focus({ preventScroll: true });
  }, [showLogin]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    await session.unlock(username, password);
    setSubmitting(false);
  };

  return (
    <div className="site-gate">
      <div className="site-gate__image" aria-hidden="true" />
      <div className="site-gate__scrim" aria-hidden="true" />
      <div className="site-gate__content">
        <p className="site-gate__eyebrow mono">MISSION // CLASSIFIED</p>
        <h1 className="site-gate__title">בקרוב...</h1>
      </div>
      <div className="site-gate__footer">
        {!showLogin ? (
          <button
            type="button"
            className="site-gate__reveal"
            onClick={() => setShowLogin(true)}
            aria-label="כניסה"
          >
            <span className="status-dot status-dot--locked" />
          </button>
        ) : (
          <form onSubmit={handleSubmit} className="term-panel site-gate__form">
            <label className="form-field">
              <span>שם משתמש</span>
              <input
                type="text"
                autoComplete="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                ref={usernameRef}
              />
            </label>
            <label className="form-field">
              <span>סיסמה</span>
              <input
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </label>
            {session.error && <div className="form-error">{session.error}</div>}
            <button type="submit" className="btn btn--primary" disabled={submitting}>
              {submitting ? 'בודק...' : 'כניסה'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
